<template>
  <div class="layout-container">
    <el-container style="height: 100%">
      <el-aside width="200px" class="sidebar">
        <div class="logo">
          <h3>预约管理后台</h3>
        </div>
        <el-menu
          default-active="$route.path"
          class="el-menu-vertical-demo"
          router
          background-color="#2f3a4a"
          text-color="#bfcbd9"
          active-text-color="#409EFF"
        >
          <!-- 保管员菜单 -->
          <template v-if="isStorekeeper">
            <el-menu-item index="/outbound-dispensing">
              <i class="el-icon-s-promotion"></i>
              <span slot="title">出库放粮</span>
            </el-menu-item>
            <el-menu-item index="/vehicle-grain-monitoring">
              <i class="el-icon-view"></i>
              <span slot="title">车辆装粮监控</span>
            </el-menu-item>
            <el-menu-item index="/warehouse-monitoring-config">
              <i class="el-icon-video-camera"></i>
              <span slot="title">发粮口设备配置</span>
            </el-menu-item>
          </template>

          <!-- 购销科菜单 -->
          <template v-else-if="isSales">
            <el-menu-item index="/broker-auth-audit">
              <i class="el-icon-postcard"></i>
              <span slot="title">经纪人认证审核</span>
            </el-menu-item>
            <el-menu-item index="/appointment-audit">
              <i class="el-icon-document"></i>
              <span slot="title">预约审批</span>
            </el-menu-item>
          </template>

          <!-- 管理员菜单 -->
          <template v-else>
            <el-menu-item index="/dashboard">
              <i class="el-icon-s-home"></i>
              <span slot="title">首页</span>
            </el-menu-item>
            <el-submenu index="audit">
              <template slot="title">
                <i class="el-icon-s-check"></i>
                <span>审批管理</span>
              </template>
              <el-menu-item index="/broker-auth-audit">
                <i class="el-icon-postcard"></i>
                <span slot="title">认证审核</span>
              </el-menu-item>
              <el-menu-item index="/appointment-audit">
                <i class="el-icon-document"></i>
                <span slot="title">预约审批</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="system">
              <template slot="title">
                <i class="el-icon-s-tools"></i>
                <span>系统管理</span>
              </template>
              <el-menu-item index="/user-manage">
                <i class="el-icon-user-solid"></i>
                <span slot="title">用户管理</span>
              </el-menu-item>
              <el-menu-item index="/driver-manage">
                <i class="el-icon-truck"></i>
                <span slot="title">司机管理</span>
              </el-menu-item>
              <el-menu-item index="/grain-type-manage">
                <i class="el-icon-sunny"></i>
                <span slot="title">品种管理</span>
              </el-menu-item>
              <el-menu-item index="/warehouse-manage">
                <i class="el-icon-office-building"></i>
                <span slot="title">仓房管理</span>
              </el-menu-item>
              <el-menu-item index="/modbus-device">
                <i class="el-icon-s-grid"></i>
                <span slot="title">设备管理</span>
              </el-menu-item>
              <el-menu-item index="/warehouse-monitoring-config">
                <i class="el-icon-setting"></i>
                <span slot="title">发粮口设备配置</span>
              </el-menu-item>
              <el-menu-item index="/outbound-dispensing">
                <i class="el-icon-s-promotion"></i>
                <span slot="title">出库放粮</span>
              </el-menu-item>
              <el-menu-item index="/vehicle-grain-monitoring">
                <i class="el-icon-view"></i>
                <span slot="title">车辆装粮监控</span>
              </el-menu-item>
              <el-menu-item index="/qrcode-manage">
                <i class="el-icon-picture-outline"></i>
                <span slot="title">二维码管理</span>
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header class="header">
          <div class="header-left">
            <span>欢迎使用预约后台管理系统</span>
          </div>
          <div class="header-right">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                <i class="el-icon-user-solid"></i>
                {{ displayName }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        <el-main class="main-content">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { getCurrentUser, isStorekeeperRole, isSalesRole } from '../utils/auth'

const ROLE_LABEL = {
  admin: '管理员',
  sales: '购销科',
  storekeeper: '保管员'
}

export default {
  name: 'Layout',
  data() {
    return {
      user: {
        name: '管理员',
        role: 'admin'
      }
    }
  },
  computed: {
    isStorekeeper() {
      return isStorekeeperRole(this.user.role)
    },
    isSales() {
      return isSalesRole(this.user.role)
    },
    displayName() {
      const label = ROLE_LABEL[this.user.role] || '用户'
      return this.user.name ? `${this.user.name}（${label}）` : label
    }
  },
  created() {
    this.user = getCurrentUser()
    if (!this.user.name) {
      this.user.name = ROLE_LABEL[this.user.role] || '用户'
    }
  },
  methods: {
    handleCommand(command) {
      if (command === 'logout') {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        this.$router.push('/login')
        this.$message.success('已退出登录')
      }
    }
  }
}
</script>

<style scoped>
.layout-container {
  width: 100%;
  height: 100%;
}

.sidebar {
  background-color: #2f3a4a;
  overflow: hidden;
}

.logo {
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: #26303d;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
}

.el-menu-vertical-demo {
  border-right: none;
}

.header {
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.header-left {
  color: #666;
  font-size: 16px;
}

.header-right {
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
    display: flex;
    align-items: center;
    gap: 5px;
  }
}

.main-content {
  background-color: #f0f2f5;
}
</style>
